import { CookiePreferences } from "./types";

export const fallbackDefaults: CookiePreferences = {
  functional: true,
  performance: false,
  advertising: false,
  social: false,
};
